module.exports = __webpack_public_path__ + "static/announcement.b3c76edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/UseCases/announcement.png
// module id = 516
// module chunks = 44921922015344